import { usePaymentApiV1 } from '../../clients/quipli-service/payment/payment-api-v1';
import { useEffect, useRef, useState } from 'react';
import { StripeConfig } from '../../clients/quipli-service/payment/payment';
import { useAdmin } from '../../hooks/use-admin-context';
import { loadStripe, SetupIntent, Stripe } from '@stripe/stripe-js';
import { toast } from '../../util/toasts';

export const StripeFinancialsConnection = ({ fullName, close }: { fullName: string; close: () => void }) => {
  const { getStripeSettingsAdmin, createConnectSetupIntent, addBankDetails } = usePaymentApiV1();
  const [stripeSettings, setStripeSettings] = useState<StripeConfig>();
  const [stripe, setStripe] = useState<Stripe>();
  const [setupIntent, setSetupIntent] = useState<SetupIntent>();
  const [initialized, setInitialized] = useState<boolean>();
  const ref = useRef<HTMLDivElement>(null);

  const admin = useAdmin();

  useEffect(() => {
    getStripeSettingsAdmin().then((settings) => {
      setStripeSettings(settings);
      loadStripe(settings.publishableKey).then((stripe) => {
        if (stripe) {
          setStripe(stripe);
          createConnectSetupIntent().then(setSetupIntent);
        } else {
          throw new Error('Unable to retrieve stripe instance');
        }
      });
    });
  }, []);

  useEffect(() => {
    if (stripeSettings && stripe && setupIntent && !initialized) {
      setInitialized(true);
      stripe
        .collectBankAccountForSetup({
          clientSecret: setupIntent.client_secret!,
          params: {
            payment_method_type: 'us_bank_account',
            payment_method_data: {
              billing_details: {
                name: fullName,
                email: admin.email,
              },
            },
          },
          expand: ['payment_method'],
        })
        .then(({ setupIntent, error }) => {
          if (error) {
            toast(`Unable to add bank details: ${error.message}`, 'error');
            setInitialized(false);
            close();
          } else {
            if (setupIntent && setupIntent.status === 'requires_confirmation') {
              // Your user provided bank account details

              // When you pass `expand: ['payment_method']` to `collectBankAccountForSetup`,
              // `setupIntent.payment_method` has data about the Payment Method, including
              // the Financial Connections Account ID, if your user used Financial Connections
              // to provide their bank account details.

              return stripe.confirmUsBankAccountSetup(setupIntent.client_secret!).then(({ setupIntent, error }) => {
                if (error) {
                  // Inform your user that there was an error, check your request logs for errors
                  console.log(error.message);
                } else {
                  if (setupIntent.status === 'succeeded') {
                    // Setup Intent confirmed, Payment Method attached to the Customer
                    console.log(`Adding bank details ${setupIntent.payment_method}`);
                    addBankDetails(setupIntent.payment_method! as string).then(() => {
                      setInitialized(false);
                      close();
                    });
                  } else {
                    // Unable to confirm the SetupIntent, re-fetch the SetupIntent for details
                  }
                }
              });
            } else {
              // Your user did not provide bank account details. you can
              // re-prompt them using `collectBankAccountForSetup`
              close();
              return null;
            }
          }
        });
    }
  }, [setupIntent]);

  return (
    <div>
      <div ref={ref}></div>
    </div>
  );
};
